import { EmptyScreen, type EmptyScreenProps } from './EmptyScreen';

type ErrorScreenProps = EmptyScreenProps;

export function ErrorScreen(props: ErrorScreenProps) {
  return <EmptyScreen {...props} />;
}
